<script setup lang="ts">
const form = useForm({
	method: 'POST',
	url: route('login'),
	fields: {
		email: '',
		password: '',
		remember: true,
	},
})
const status = useProperty<string | null>('status')
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/security.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<ui-card-content>
		<ui-alert v-if="status" class="mb-4" variant="informative">
			{{ status }}
		</ui-alert>

		<ui-form @submit.prevent="form.submit">
			<ui-form-item>
				<ui-label for="email">
					{{ t('validation.attributes.email') }}
				</ui-label>
				<ui-input
					id="email"
					v-model="form.fields.email"
					required
					autofocus
					autocapitalize="off"
					autocomplete="username"
					autocorrect="off"
					type="email"
				/>
				<ui-form-error :message="form.errors.email" />
			</ui-form-item>

			<ui-form-item>
				<ui-label for="password">
					{{ t('validation.attributes.password') }}
				</ui-label>
				<ui-input
					id="password"
					v-model="form.fields.password"
					required
					autocapitalize="off"
					autocomplete="current-password"
					autocorrect="off"
					type="password"
				/>
				<ui-form-error :message="form.errors.password" />
			</ui-form-item>

			<ui-form-item variant="control">
				<ui-checkbox
					id="remember"
					v-model="form.fields.remember"
				/>
				<ui-label for="remember" class="font-normal">
					{{ t('validation.attributes.remember') }}
				</ui-label>
			</ui-form-item>

			<ui-button type="submit" :loading="form.processing">
				{{ t('app.buttons.sign_in') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>

			<div class="text-center text-sm">
				<ui-link :href="route('password.request')">
					{{ t('app.buttons.forgot_your_password') }}
				</ui-link>
			</div>
		</ui-form>
	</ui-card-content>

	<ui-card-footer :class="cn('rounded-b-none sm:rounded-b-xl', $attrs.class ?? '')">
		<div class="flex w-full items-center justify-center gap-1 text-sm text-gray-500">
			<span>{{ t('app.no_account_yet') }}</span>
			<ui-link :href="route('register')">
				{{ t('app.buttons.create_an_account') }}
			</ui-link>
		</div>
	</ui-card-footer>
</template>
